import { useEffect, useRef } from 'react';

/**
 * Brings an element into view once it is the one a link pointed at —
 * `/projects/:id/locations?place=123` from a conversation's place preview.
 * Instant rather than smooth for a reader who asked for reduced motion.
 * `scrollIntoView` is absent in jsdom, hence the optional call.
 */
export function useScrollIntoViewWhen<T extends HTMLElement>(when: boolean) {
  const ref = useRef<T | null>(null);
  useEffect(() => {
    if (!when) return;
    const reduce =
      typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
    ref.current?.scrollIntoView?.({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }, [when]);
  return ref;
}

/** The outline a pointed-at card wears, so the eye lands on it after the scroll. */
export const POINTED_AT_STYLE = { outline: '3px solid var(--ink)', outlineOffset: 3 } as const;
